import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SIGN_IN_URL, SIGN_OUT_URL, LANDING_PAGE_URL } from '../const/APIUrl.js';
import { LOCAL_STORAGE_USER } from '../const/LocalStorage.js';
import { trim } from '../helpers/String.js';

const initialState = {
    loginResponse: null,
    pageAccess: null,    
    isLoading: true,
    error: null,
    isAuthenticated: false,
    authStatus: '',
};



export const doSignIn = createAsyncThunk(
    SIGN_IN_URL,
    async ({ username, password }, { rejectWithValue }) => {
        try {

            if (trim(username) === '' || trim(password) == '') {
                return rejectWithValue(
                {
                    allErrorMessages: ["Please fill username and password"]          
                });
            }

            const response = await fetch(SIGN_IN_URL, {        
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ username, password, userAgent : window.navigator.userAgent }),
            });
            
            if (!response.ok) {
                const errorData = await response.json();                
                return rejectWithValue(errorData);
            }
            const data = await response.json();
                        
            let pageFunctions : {}[] = [];
            let functionValues = {};
            let prevPageId = -1;

            data.PageFunction.map(d => {
                if (prevPageId != d.PageId)
                {            
                    if (Object.keys(functionValues).length > 0) pageFunctions.push(functionValues);
                    functionValues = { pageId : d.PageId };
                }

                functionValues[d.FunctionName] = true;
                prevPageId = d.PageId;
            })

            if (Object.keys(functionValues).length > 0) pageFunctions.push(functionValues);
            data.PageFunctionMap = pageFunctions;        
            
            localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify(data));

            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const doSignOut = createAsyncThunk(
    SIGN_OUT_URL,
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetch(SIGN_OUT_URL, {        
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
            });

            if (!response.ok) {
                const errorData = await response.json();
                return rejectWithValue(errorData);
            }
            
            const data = await response.json();

            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const doAuthorize = createAsyncThunk(
    LANDING_PAGE_URL,
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetch(LANDING_PAGE_URL, {        
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
            });

            if (!response.ok) {
                const errorData = await response.json();
                return rejectWithValue(errorData);
            }

            const data = await response.json();            

            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        getLoggedInUser: (state) => {
             var loggedInResponse = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
             state.loginResponse = loggedInResponse;             
             //state.pageAccess = userDetail.PageAccess;
             state.isAuthenticated = loggedInResponse !== undefined || loggedInResponse !== null;
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(doSignIn
        .pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(doSignIn
        .fulfilled, (state, action) => {
            state.isLoading = false;                    
            state.loginResponse = action.payload;
            state.isAuthenticated = true;
            state.authStatus = 'loggedin';
        })
        .addCase(doSignIn
        .rejected, (state, action) => {            
            state.isLoading = false;
            state.loginResponse = null;
            state.error = action.payload;            
        })
        .addCase(doSignOut
            .pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(doSignOut
        .fulfilled, (state, action) => {
            state.isLoading = false;                    
            state.loginResponse = null;
            state.isAuthenticated = false;
            state.authStatus = 'logout';
            localStorage.clear();
        })
        .addCase(doSignOut
        .rejected, (state, action) => {
            state.isLoading = false;
            state.loginResponse = null;
            state.error = action.payload;
        })
        .addCase(doAuthorize
            .pending, (state) => {            
            state.isLoading = true;
            state.error = null;
        })
        .addCase(doAuthorize
        .fulfilled, (state, action) => {    
            //state.authStatus = 'notauthorized';                   
            state.isLoading = false;                    
            state.isAuthenticated = true;                       
        })
        .addCase(doAuthorize
        .rejected, (state, action) => {
            state.authStatus = 'notauthorized';
            state.isLoading = false;  
            state.isAuthenticated = false;
        });
    },
});

export const authActions = authSlice.actions;

export default authSlice.reducer;